import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderBar } from '@shared/components/header-bar';

/** The application bar once, and under it the routed page taking the remaining height. */
@Component({
  imports: [HeaderBar, RouterOutlet],
  template: `
    <div class="flex h-dvh w-full flex-col overflow-hidden">
      <mai-header-bar class="shrink-0"></mai-header-bar>
      <router-outlet></router-outlet>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppLayout {}
